var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    {
      staticClass: "contacts-banner elevation-1 overflow-hidden mb-4",
      class: {
        "rounded-sm pa-6": !_setup.isMobile,
        "contacts-banner--mobile px-4 py-8": _setup.isMobile,
      },
      attrs: { "data-qa": "contacts-banner" },
    },
    [
      _c(
        "div",
        { staticClass: "position-relative text-subtitle-1 bg-gray-0--text" },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _setup.t(
                  "Наша политика - открытость и клиентоориентированность. Пожалуйста, свяжитесь с нами любым удобным способом. Будем рады оказаться полезными!",
                  _setup.options
                )
              ) +
              "\n  "
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }